module.exports = __webpack_public_path__ + "img/plane.3a0a29f2.svg";